import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthService } from '../../services/authentication/auth.service';
import { Session } from '../../services/authentication/session';

@Component({
   selector: 'logout',
   template: ''
})
export class LogoutComponent { 
    
    constructor(private authService: AuthService) {
    }

    ngOnInit() {
       this.authService.logoutUser(true);
    }       
} 